module.exports = __webpack_public_path__ + "img/information.cfbbb270.png";